import { getContent } from '../../utils/tileUtils';
import Breadcrumbs, { getCrumbs } from '../common/Breadcrumbs';
import PromoBox from '../includes/PromoBox';
import SearchVolunteerPeerForm from '../includes/search/SearchVolunteerPeerForm';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';

const SearchVolunteerPeer = ({ tileContent }) => {
  const location = useLocation();

  const passedCrumbs = location.state?.breadCrumbs || [];
  const currentCrumb = {
    title: 'search volunteers',
    url: location.pathname,
    params: location.search,
  };

  const breadCrumbs = getCrumbs(passedCrumbs, currentCrumb, 'SearchVolunteerPeer');

  return (
    <div className="ContactPage">
      {/* Subtitle */}
      {tileContent && tileContent.subtitle && (
        <PromoBox>
          <p className="intro">{tileContent.subtitle}</p>
        </PromoBox>
      )}
      <Breadcrumbs crumbs={breadCrumbs} />
      <SearchVolunteerPeerForm />
    </div>
  );
};

const mapStateToProps = (state) => ({
  tileContent: getContent(state.config.content.tiles, 'volunteer_search'),
});

export default connect(mapStateToProps)(SearchVolunteerPeer);
